import { createContext } from 'react'

interface HelperEditorContextValue {
    suggestions: Array<{ path: string, label: string }>
    autoOpenNodeKey: string | null
    clearAutoOpen: () => void
}

export const HelperEditorContext = createContext<HelperEditorContextValue>({
    suggestions: [],
    autoOpenNodeKey: null,
    clearAutoOpen: () => {},
})
